import { render, staticRenderFns } from "./CompanyWizard.vue?vue&type=template&id=983afe98&scoped=true&"
import script from "./CompanyWizard.vue?vue&type=script&lang=js&"
export * from "./CompanyWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983afe98",
  null
  
)

export default component.exports